import {
  Props as SelectProps,
  AsyncProps,
  GroupBase,
  AsyncSelect,
  Select,
  ChakraStylesConfig,
} from "chakra-react-select";

export const defaultOptionStyles = {
  color: "bright.500",
  background: "dark.400",
  borderRadius: "0",
  border: "0",
  fontSize: "md",
  ":hover": {
    background: "dark.500",
    color: "secondary.500",
  },
  ":focus": {
    background: "dark.500",
  },
  ":active": {
    background: "dark.500",
  },
};

const getStylesConfig = <
  Option extends unknown,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(): ChakraStylesConfig<Option, IsMulti, Group> => ({
  dropdownIndicator: (provided) => ({
    ...provided,
    bg: "transparent",
    px: "2",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    borderLeftWidth: "0",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "dark.400",
    opacity: 0.5,
  }),
  downChevron: (provided) => ({
    ...provided,
    w: "7",
    hueRotate: "auto",
  }),
  crossIcon: (provided) => ({
    ...provided,
    w: "7",
    h: "auto",
  }),
  menuList: (provided) => ({
    ...provided,
    bg: "dark.400",
    borderRadius: "0",
    border: "0",
    py: "2",
    w: "auto",
    minW: "0",
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize: "sm",
    color: "bright.500",
    opacity: "0.5",
  }),
  option: (provided) => ({
    ...provided,
    ...defaultOptionStyles,
  }),
});

export type SmartSelectProps<
  Option extends unknown,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = SelectProps<Option, IsMulti, Group>;

const SmartSelect = <
  Option extends unknown,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  chakraStyles = {},
  ...rest
}: SmartSelectProps<Option, IsMulti, Group>) => (
  <Select
    focusBorderColor="secondary.500"
    chakraStyles={{
      ...getStylesConfig<Option, IsMulti, Group>(),
      ...chakraStyles,
    }}
    {...rest}
  />
);

export type AsyncSmartSelectProps<
  Option extends unknown,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = AsyncProps<Option, IsMulti, Group>;

export const AsyncSmartSelect = <
  Option extends unknown,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  chakraStyles = {},
  ...rest
}: AsyncSmartSelectProps<Option, IsMulti, Group>) => (
  <AsyncSelect
    focusBorderColor="secondary.500"
    chakraStyles={{
      ...getStylesConfig<Option, IsMulti, Group>(),
      ...chakraStyles,
    }}
    {...rest}
  />
);

export default SmartSelect;
